import { useEffect, useState } from "react";
import AdminService from "../../../../../service/AdminService";
import OrderService from "../../../../../service/OrderService";
import PhysicalStoreService from "../../../../../service/PhysicalStoreService";

// Mesmas consultas que a Home clássica faz para mostrar os toasts de pendência.
// Cada contador é independente: `null` enquanto carrega, `undefined` se a consulta falhar.
const PENDING_SOURCES = {
  bankTransfers: async () => {
    const res = await new OrderService().getPendingTransfers();
    if (res.messageCode !== 200001) throw new Error(res.messageCode);
    return res.result?.length ?? 0;
  },
  pendingOrders: async () => {
    const res = await new AdminService().getPendingOrders(
      localStorage.getItem("__extraconomy_token"),
    );
    return res.result?.length ?? 0;
  },
  withdrawRequests: async () => {
    const res = await new AdminService().getAllWithdrawRequests(
      localStorage.getItem("__extraconomy_token"),
      localStorage.getItem("__extraconomy_username"),
    );
    return (res.result || []).filter((withdraw) => withdraw.status === "PROCESSING").length;
  },
  bangoodOrders: async () => {
    const res = await new AdminService().getBangoodRequests(
      localStorage.getItem("__extraconomy_token"),
    );
    if (res.messageCode !== 200001) throw new Error(res.messageCode);
    return (res.result || []).filter((item) => item.status_order_banggood === "NOT PROCESSED")
      .length;
  },
  physicalStores: async () => {
    const res = await new PhysicalStoreService().getPendingVerifications();
    if (res.messageCode !== 200001) throw new Error(res.messageCode);
    return res.result?.length ?? 0;
  },
};

const initialCounts = Object.fromEntries(Object.keys(PENDING_SOURCES).map((key) => [key, null]));

const useAdminPendingCounts = () => {
  const [counts, setCounts] = useState(initialCounts);

  useEffect(() => {
    let cancelled = false;

    Object.entries(PENDING_SOURCES).forEach(([key, load]) => {
      load()
        .then((count) => !cancelled && setCounts((prev) => ({ ...prev, [key]: count })))
        .catch((e) => {
          console.log(e);
          if (!cancelled) setCounts((prev) => ({ ...prev, [key]: undefined }));
        });
    });

    return () => {
      cancelled = true;
    };
  }, []);

  return counts;
};

export default useAdminPendingCounts;
